<template>
  <div class="specials section-pad" id="gospecial">
    <div class="container">
      <h5 class="main-title text-center">{{ $t('specialsComp.ourFeatures') }}</h5>
      <div class="col-md-6 col-12 mb-4 mt-5 margin-auto">
        <p class="main-p gray-col text-center">
          {{ $t('specialsComp.appDescription') }}
        </p>
      </div>
      <div class="special-boxes">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-12 mb-3" v-for="special in advantages" :key="special.id">
            <div class="special-box text-center">
              <div class="img-special-cont">
                <img :src="special.image" alt="" />
              </div>
              <div class="special-text">{{ special.title }}</div>
              <p class="main-p">
                {{ special.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {  defineProps, onMounted } from "vue";

// props
const props = defineProps(["advantages"]);

onMounted(() => {
  console.log(props);
});
</script>
